import axios, { AxiosResponse } from 'axios';
import { action, atom, onMount } from 'nanostores';
import {
  ScoreLogic,
  ScoreLogicService,
  CreateScoreLogicRequest,
  EventType,
  EventTypesInfo,
} from '../api';


export const $loadingScoreLogics = atom<boolean>(false);
export const $loadingEventTypes = atom<boolean>(false);

export const $scorelogic = atom<ScoreLogic | undefined>();

export const $scorelogics = atom<ScoreLogic[]>([]);

export const $eventTypes = atom<EventTypesInfo[]>([]);

/**
 * Main function to load score logics.
 */
export const loadScoreLogics = async (organizationId: string) => {
  console.log('Retrieving score logics...');
  $loadingScoreLogics.set(true); // Set loading state to true
  $loadingEventTypes.set(true); // Set loading state to true

  await ensureOrganization(organizationId);

  var response = await ScoreLogicService.getScoreLogics(organizationId);
  $scorelogics.set(response.scoreLogics ?? []);
  $eventTypes.set(response.eventTypes ?? []);
  console.log('Event Types:');
  console.log($eventTypes.get());

  $loadingScoreLogics.set(false); // Set loading state back to false
  $loadingEventTypes.set(false); // Set loading state back to false 
};

/**
 * Watch for route changes; if we haven't loaded the score logics, we try to load them.
 */
route.subscribe(async name => {
  if (name !== 'score_logic' || ($scorelogics.value?.length ?? 0) > 0) {
    return;
  }

  const params = $router.get()?.params as Record<'organizationId', string>;

  await loadScoreLogics(params.organizationId);
});

/**
 * Watch for route changes; load the current selected project result.
 */
// route.subscribe(async name => {
//   if (name !== 'project') {
//     return;
//   }

//   const params = $router.get()?.params as Record<'organizationId', string> &
//     Record<'workspaceId', string> &
//     Record<'projectId', string>;

//   await loadProjectResult(
//     params.organizationId,
//     params.workspaceId,
//     params.projectId,
//   );
// });

/**
 * Main function to load project result.
 */
// const loadProjectResult = async (
//   organizationId: string,
//   workspaceId: string,
//   projectId: string,
// ) => {
//   console.log('Retrieving project result...');

//   await ensureOrganization(organizationId);
//   await ensureWorkspace(workspaceId);
//   await ensureProject(projectId);
//   var projectResult = await ProjectsService.downloadResults(projectId);

//   $projectResult.set(projectResult);
// };

/**
 * Create a new workspace
 * TODO: Include profile selection/invites.
 */
export const createScoreLogic = action(
  $scorelogic,
  'createScoreLogic',
  async (
    store,
    name: string,
    organizationId: string,
    accountReceivableId: string,
    eventType: EventType,
    condition: string,
    impactValue: number,
    priority: number,
    isActive: boolean,
  ) => {
    const request: CreateScoreLogicRequest = {
      name: name,
      organizationId: organizationId,
      accountReceivableId: accountReceivableId,
      eventType: eventType,
      condition: condition,
      impactValue: impactValue,
      priority: priority,
      isActive: isActive,
    };

    const response = await ScoreLogicService.createScoreLogic(organizationId, request);

    if (!response.scoreLogic) {
      // error is displayed by caller
      return response;
    }

    $scorelogic.set(response.scoreLogic);

    $scorelogics.set([response.scoreLogic, ...$scorelogics.get()]);
    return response;
  },
);

/**
 * Delete's the selected project.
 */
export const deleteScoreLogic = action(
  $scorelogic,
  'deleteScoreLogic',
  async (store, organizationId: string, scorelogicId: string) => {
    await ScoreLogicService.deleteScoreLogic(organizationId, scorelogicId);

    $scorelogic.set(undefined);

    // Splice out the project
    const scorelogics = $scorelogics.get();

    const index = scorelogics.findIndex(p => p.id === scorelogicId);

    if (index > -1) {
      scorelogics.splice(index, 1);

      $scorelogics.set(scorelogics);
    }
  },
);

/**
 * Ensure that the project is loaded and selected.
 */
export const ensureScoreLogic = action(
  $scorelogic,
  'ensureScoreLogic',
  async (store, scorelogicId: string) => {
    let scoreLogic: ScoreLogic | undefined;

    const params = $router.get()?.params as Record<'organizationId', string>;

    if ($scorelogics.get().length === 0) {
      const scorelogics = await ScoreLogicService.getScoreLogics(
        params.organizationId ?? '',
      );

      $scorelogics.set(scorelogics.scoreLogics ?? []);
      $eventTypes.set(scorelogics.eventTypes ?? []);
      scoreLogic = scorelogics.scoreLogics?.find(p => p.id === scorelogicId);
    } else {
      scoreLogic = $scorelogics.get().find(p => p.id === scorelogicId);
    }

    $scorelogic.set(scoreLogic);
  },
);  